import { createContext, useState } from "react";

interface GenerateDeliveryNotePdfActionContextType {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  deliveryNoteId: string | number | null;
  setDeliveryNoteId: (id: string | number | null) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  sendToCustomer: boolean;
  setSendToCustomer: (send: boolean) => void;
}

export const GenerateDeliveryNotePdfActionContext = createContext<GenerateDeliveryNotePdfActionContextType>({
  showModal: false,
  setShowModal: () => {},
  deliveryNoteId: null,
  setDeliveryNoteId: () => {},
  loading: false,
  setLoading: () => {},
  sendToCustomer: true,
  setSendToCustomer: () => {},
});

export const GenerateDeliveryNotePdfActionProvider: React.FC<{ children: any }> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [deliveryNoteId, setDeliveryNoteId] = useState<string | number | null>(null);
  const [loading, setLoading] = useState(false);
  const [sendToCustomer, setSendToCustomer] = useState(true);

  return (
    <GenerateDeliveryNotePdfActionContext.Provider value={{ showModal, setShowModal, deliveryNoteId, setDeliveryNoteId, loading, setLoading, sendToCustomer, setSendToCustomer }}>
      {children}
    </GenerateDeliveryNotePdfActionContext.Provider>
  );
};
